import React from 'react';
import { Link } from 'react-router-dom';
import { Mail } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-black text-white py-16">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
          {/* Company Info */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="h-10 w-10 bg-white rounded-full flex items-center justify-center flex-shrink-0">
                <img 
                  src="https://customer-assets.emergentagent.com/job_forai-portfolio/artifacts/f1qjy67i_AI4SUSTAINABILITY_MAHENDRA.png" 
                  alt="Centre for Sustainable AI Logo" 
                  className="h-8 w-8 object-contain"
                />
              </div>
              <h3 className="text-lg font-light">The Centre for Sustainable AI</h3>
            </div>
            <p className="text-sm text-gray-400">
              Global Leadership in Ethical, Responsible, and Sustainable Artificial Intelligence
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-light mb-4">Quick Links</h3>
            <div className="space-y-2">
              <Link to="/overview" className="block text-sm text-gray-400 hover:text-white transition-colors duration-200">
                Overview
              </Link>
              <Link to="/services" className="block text-sm text-gray-400 hover:text-white transition-colors duration-200">
                Our Services
              </Link>
              <Link to="/resources" className="block text-sm text-gray-400 hover:text-white transition-colors duration-200">
                Resources
              </Link>
              <Link to="/careers" className="block text-sm text-gray-400 hover:text-white transition-colors duration-200">
                Careers
              </Link>
              <Link to="/contact" className="block text-sm text-gray-400 hover:text-white transition-colors duration-200">
                Contact Us
              </Link>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-light mb-4">Get in Touch</h3>
            <a
              href="mailto:support@aiesg.org"
              className="flex items-center gap-2 text-sm text-gray-400 hover:text-white transition-colors duration-200"
            >
              <Mail size={16} />
              support@aiesg.org
            </a>
            <p className="text-sm text-gray-400 mt-4">
              We operate around the clock as a global organisation, supporting clients worldwide.
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-800 flex flex-col sm:flex-row justify-between items-center">
          <p className="text-sm text-gray-400">
            © {new Date().getFullYear()} The Centre for Sustainable AI. All rights reserved.
          </p>
          <div className="flex gap-6 mt-4 sm:mt-0">
            <Link to="/privacy" className="text-sm text-gray-400 hover:text-white transition-colors duration-200">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-sm text-gray-400 hover:text-white transition-colors duration-200">
              Terms & Conditions
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
